import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import Svg from '../../components/icons/svg';
import { Context } from '../../../context/global-data-provider';
import './menu-category-style.css';

export default function MenuMainCategory() {
  const [open, setOpen] = useState(false);
  const { categories } = useContext(Context);

  function toggleOpen() {
    setOpen(!open);
  }

  function closeMenu() {
    setOpen(false);
  }

  return (
    <div className="menu-category">
      <button type="button" className="toggle-button" onClick={toggleOpen}>
        <Svg name={'menuCircle'} height={22} width={22} fill={'#262626'} label={'Menu'} />
      </button>
      {open && (
        <div>
          <div className="menu-nav-closer" onClick={closeMenu} />
          <div className="menu-nav">
            <div className="title">گالری محصولات</div>
            <ul>
              {Object.keys(categories).map((key) => {
                return (
                  <li className="item" onClick={closeMenu} key={'mgc-' + key}>
                    <Link to={`/category/${categories[key].id}/${categories[key].uniq_title}`}>
                      {categories[key].title}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}
